// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"549":"af37dea1","895":"8adbada2","930":"54bcb5f1"}[chunkId] + ".js";
};